import React from 'react';
import { useParams } from 'react-router-dom';
import { PAGE_TYPE_TO_COMPONENT_TYPE } from '../constants/pageTypesToComponentMap';

const RedirectPage = () => {
  const { redirectingData } = useParams();

  const decodedString = atob(redirectingData);
  const decodedObject = JSON.parse(decodedString);
  const Component = PAGE_TYPE_TO_COMPONENT_TYPE[decodedObject.pageType];

  return <Component data={decodedObject.data} />;
};

export default RedirectPage;
